import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const appomni = defineConnector({
  identifier: "appomni",
  name: "AppOmni",
  tagLine: "SaaS security posture management",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(baseUrl || "https://your-instance.appomni.com/api/v1"),
  auth: headerAuth([
    {
      name: "Authorization",
      value: { from: "template", template: "Bearer {secrets.apiToken}" },
    },
  ]),
  steps: [
    {
      title: "Set up AppOmni",
      items: [
        {
          kind: "markdown",
          content:
            "In your AppOmni instance, open **Settings → API Settings** and create an API token with access to the services you want to use. Copy the token and enter your instance’s API base URL. See the [AppOmni API documentation](https://api.appomni.com/).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "url",
          label: "API base URL",
          required: true,
          placeholder: "https://your-instance.appomni.com/api/v1",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText: "Use your AppOmni instance hostname followed by /api/v1.",
        },
        {
          kind: "input",
          label: "AppOmni API token",
          required: true,
          target: {
            kind: "secrets",
            field: "apiToken",
          },
          helperText:
            "Access token created or configured in the AppOmni tenant under Settings → API Settings. The official documentation does not specify token scope or minimum permissions.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://your-instance.appomni.com/api/v1")
          .trim()
          .replace(/\/+$/, "") + "/core/monitoredservice/?limit=1",
      ...{ method: "GET" },
    }),
  },
});
